import dotenv from 'dotenv';

const config = {
  API_URL: process.env.REACT_APP_API_URL || '',
  JOBSEEKER_API_URL: process.env.REACT_APP_JOBSEEKER_API_URL || '',
  CRYPTO_SECRET_KEY: process.env.REACT_APP_CRYPTO_SECRET_KEY || '',
  JWT_SECRET: process.env.REACT_APP_JWT_SECRET || '',
};

export default config;